export class PluginData {
  siteUrl: string;
  returnUrl: string;
  nonce: string;
  pluginId: string;
  pluginName: string;
  version: string;
  isNewConnectionFlow: boolean;
  fromPlugin: string;
  onlyOptimize: boolean;

  constructor(data: any) {
    this.siteUrl = data.site_url || '';
    this.returnUrl = data.return_url || '';
    this.nonce = data.nonce || '';
    this.pluginId = data.plugin_id || '';
    this.pluginName = data.utm_source || '';
    this.version = data.version || '';
    this.isNewConnectionFlow = !!data.new_connection_flow;
    this.fromPlugin = data.from_plugin || '';
    this.onlyOptimize = !!data.two_only_optimize || false;
  }
}
